import { ReactNode } from "react";

import styles from "./Tag.module.scss";

type TagProps = {
  icon: ReactNode;
  value: string;
};

const Tag: React.FC<TagProps> = ({ icon, value }) => (
  <div className={styles.tag}>
    {icon}
    <span className="text-sm font-normal">{value}</span>
  </div>
);

export default Tag;
